import { useModals } from 'almanac-ui/Modal'
import { useBrandVoicePaywall } from './useBrandVoicePaywall'
import { IntroModal } from 'screens/BrandKits/components/BrandVoice/AddVoice/IntroModal'
import { useRootStore } from 'stores/RootStore'
import { CTA } from 'stores/OnboardingStore'
import {
  AnalyseContentModal,
  AnalyseContentModalProps,
} from 'screens/BrandKits/components/BrandVoice/AddVoice/AnalyseContentModal'
import { Options } from 'almanac-ui/Modal/Types'
import { AnalysingContentModal } from 'screens/BrandKits/components/BrandVoice/AddVoice/AnalysingContentModal'
import { EditVoiceModal } from 'screens/BrandKits/components/BrandVoice/EditVoiceModal'
import { CreateContentModal } from 'screens/BrandKits/components/BrandVoice/AddVoice/CreateContentModal'

export const useOpenBrandVoiceModal = () => {
  const { openModal, closeModals } = useModals()
  const { showBrandVoicePaywall, openBrandVoicePaywall } = useBrandVoicePaywall()
  const { onboardingStore } = useRootStore()

  return (props?: Partial<Omit<AnalyseContentModalProps, 'workspaceId' | 'close'>>, options?: Options) => {
    if (showBrandVoicePaywall) {
      openBrandVoicePaywall()
      return
    }

    if (onboardingStore.ctaCompleted(CTA.BrandVoice)) {
      return openModal(
        AnalyseContentModal,
        {
          onAnalyse: (analyseProps) =>
            openModal(AnalysingContentModal, {
              ...props,
              ...analyseProps,
              onNext: (editProps) =>
                openModal(EditVoiceModal, {
                  ...editProps,
                  onBack: () => {
                    closeModals(2)
                  },
                  onCreate: (createProps) => openModal(CreateContentModal, createProps),
                }),
            }),
          ...props,
        },
        {
          newStack: false,
          ...options,
        },
      )
    }

    return openModal(IntroModal, props, {
      newStack: false,
      ...options,
    })
  }
}
